import styled, { useTheme } from "styled-components";

interface LinkProps {
  href?: string;
  target?: string;
  key: string;
  children?: React.ReactNode;
}

export const Link = ({ href, target, key, children }: LinkProps) => {
  const { linkColor } = useTheme();
  return (
    <StyledLink href={href} target={target} key={key} $color={linkColor}>
      {children}
    </StyledLink>
  );
};

const StyledLink = styled.a<{ $color?: string }>`
  text-decoration: underline;
  color: ${({ $color }) => $color || "inherit"};
`;
